module.exports = __webpack_public_path__ + "static/media/goodlive.7307f349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/clients/goodlive.svg
// module id = 223
// module chunks = 0